
import { useTheme } from '@mui/material';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function CustomTooltip({ active, payload, label }:any) {
  const theme = useTheme();
  if (active) {
    console.log(payload[0].fill);
    return (
      <div style={{ backgroundColor: theme.colors.backgroundColor, border: `1px solid ${payload[0].fill}` }} className="custom-tooltip">
        <p className="label">{`${label}`} {`${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
}